var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigDataConsulting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 109,
    viewBox: "0 0 184 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1322_385",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 184,
    height: 109
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 109,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1322_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.074 58.4728C113.074 51.7384 118.63 46.3506 125.196 46.3506C131.931 46.3506 137.319 51.7384 137.319 58.4728C137.319 65.2071 131.931 70.595 125.196 70.595C118.462 70.595 113.074 65.2071 113.074 58.4728V58.4728Z",
    fill: "#ffffff",
    className: "secondary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.999 91.1726V100.613C149.999 101.624 149.324 102.299 148.312 102.299H102.08C101.236 102.299 100.393 101.625 100.393 100.613V91.1726C100.393 80.8891 108.83 72.4597 119.123 72.4597C119.798 72.4597 120.473 72.7965 120.81 73.3026L125.197 82.0687L129.753 73.3026C130.09 72.7965 130.597 72.4597 131.272 72.4597C141.563 72.4597 150 80.8891 150 91.1726H149.999Z",
    fill: "#ffffff",
    className: "primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6816 58.4728C46.6816 51.7384 52.0695 46.3506 58.8038 46.3506C65.5382 46.3506 70.926 51.7384 70.926 58.4728C70.926 65.2071 65.5382 70.595 58.8038 70.595C52.0695 70.595 46.6816 65.2071 46.6816 58.4728V58.4728Z",
    fill: "#ffffff",
    className: "secondary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.607 91.1726V100.613C83.607 101.624 82.9319 102.299 81.9197 102.299H35.6873C34.6751 102.299 34 101.625 34 100.613V91.1726C34 80.8891 42.4371 72.4597 52.73 72.4597C53.4051 72.4597 54.0802 72.7965 54.2487 73.3026L58.6361 82.0687L63.0235 73.3026C63.3606 72.7965 63.8671 72.4597 64.5422 72.4597C75.1714 72.4597 83.6077 80.8891 83.6077 91.1726H83.607Z",
    fill: "#ffffff",
    className: "primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.274 42.3987C123.881 43.7161 122.42 46.2046 119.353 45.4721C115.555 44.3009 112.342 42.6911 110.151 40.6418C108.106 40.9343 106.207 41.0812 104.309 40.7881C109.713 36.9821 113.073 31.2737 113.073 24.8336C113.073 18.8321 110.006 13.27 105.186 9.61084H106.354C116.725 9.61084 125.196 16.6367 125.196 25.2729C125.196 29.8108 122.859 34.0555 118.915 36.9828C119.352 38.8858 120.667 40.935 122.274 42.3988L122.274 42.3987Z",
    fill: "#ffffff",
    className: "primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.83 7.00054C77.0125 7.00054 67.3828 15.0619 67.3828 24.8824C67.3828 30.0119 70.009 34.8486 74.6779 38.3667C74.24 40.7115 72.7812 43.2034 70.8844 44.8154C69.1333 46.281 71.0301 48.9193 74.0943 48.0401C78.4709 46.7209 82.1188 44.8154 84.5987 42.4706C86.0576 42.7635 87.5165 42.9106 88.8295 42.9106C100.647 42.9106 110.277 34.8492 110.277 25.0287C110.277 15.2082 100.648 7 88.8295 7L88.83 7.00054ZM99.4802 32.7973H78.3253C77.4501 32.7973 76.8664 32.2109 76.8664 31.3317C76.8664 30.4525 77.4501 29.8661 78.3253 29.8661L99.4802 29.8655C100.355 29.8655 100.939 30.4518 100.939 31.331C100.939 32.2109 100.21 32.7973 99.4802 32.7973V32.7973ZM99.4802 26.0551H78.3253C77.4501 26.0551 76.8664 25.4688 76.8664 24.5896C76.8664 23.7103 77.4501 23.124 78.3253 23.124H99.4802C100.355 23.124 100.939 23.7103 100.939 24.5896C100.939 25.4688 100.21 26.0551 99.4802 26.0551ZM99.4802 19.4593H78.3253C77.4501 19.4593 76.8664 18.8729 76.8664 17.9937C76.8664 17.1145 77.4501 16.5281 78.3253 16.5281H99.4802C100.355 16.5281 100.939 17.1145 100.939 17.9937C100.939 18.7265 100.21 19.4593 99.4802 19.4593Z",
    fill: "#ffffff",
    className: "primary-color"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigDataConsulting);
export default __webpack_public_path__ + "static/media/big-data-consulting.b22f0c2c11f501d3896e87873d43475a.svg";
export { ForwardRef as ReactComponent };